export default {"src":"/_next/static/image/public/images/ic_doctor_image_4.50dbfe7882fb412643fa132d94a61ec1.svg","height":61,"width":58};